// umlaut-check: skip — "BestaetigenModal" ist ein Komponenten-/Dateiname
// (technischer Bezeichner), bleibt ASCII.

import React from "react";
import {Modal, OverlayTrigger, Tooltip} from "react-bootstrap";

/**
 * Generisches Bestätigungs-Modal für Cosmos-Pflegeaktionen - Ersatz für
 * `confirm()`, das im Haus nicht zugelassen ist (KONVENTIONEN.md
 * Abschnitt 4). Vorbild: Components/Cosmos/UngespeichertHinweis.jsx.
 *
 * N7 (Sichtprüfung 2, 22.09.2026): beide Knöpfe mit Erklär-Tooltip -
 * "confirmHelp"/"cancelHelp" optional, damit jeder Aufrufer den Text auf
 * seine konkrete Aktion zuschneiden kann (Rückfallwert bleibt allgemein
 * gültig für bestehende Aufrufer ohne diese Props).
 */
export default function BestaetigenModal({
    show,
    title,
    children,
    confirmLabel = "Entfernen",
    confirmVariant = "outline-danger",
    confirmHelp = "Führt die Aktion jetzt aus.",
    cancelHelp = "Schließt diesen Hinweis, ohne etwas zu ändern.",
    busy = false,
    onConfirm,
    onCancel,
}) {
    return (
        <Modal show={show} onHide={onCancel} centered aria-labelledby="cosmos-bestaetigen-title">
            <Modal.Header closeButton>
                <Modal.Title id="cosmos-bestaetigen-title" style={{fontSize: 16}}>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{fontSize: 14, lineHeight: 1.5}}>{children}</Modal.Body>
            <Modal.Footer>
                <OverlayTrigger placement="top" overlay={<Tooltip id="bestaetigen-abbrechen-tip">{cancelHelp}</Tooltip>}>
                    <span>
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCancel}>
                            Abbrechen
                        </button>
                    </span>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip id="bestaetigen-ausfuehren-tip">{confirmHelp}</Tooltip>}>
                    <span>
                        <button type="button" className={`btn btn-sm btn-${confirmVariant}`} disabled={busy} onClick={onConfirm}>
                            {busy ? "wird ausgeführt…" : confirmLabel}
                        </button>
                    </span>
                </OverlayTrigger>
            </Modal.Footer>
        </Modal>
    );
}
